import React, { MouseEvent } from 'react';

import { Popover } from '@mui/material';
import styled from 'styled-components';
import { colors } from 'spw-theme';

import { SPWMainButton } from 'spw-shared/globalComponents';
import { SPWOutlineBlackButton } from 'spw-shared/globalComponents/buttons';

export const RemoveCustomAvatarCard = styled.div`
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.08);
  padding: 24px;
  height: 130px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .header {
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: ${colors.black};
    margin-bottom: 16px;
  }
  .body {
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    color: ${colors.black};
  }
  .actions {
    > button {
      margin-right: 16px;
    }
  }
`;

const RestoreDefaultAvatarPopover = ({
  onRemove,
}: {
  onRemove: () => void;
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handlePopoverOpen = (e: MouseEvent) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handlePopoverClose = (e: MouseEvent) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const handleRemove = (e: MouseEvent) => {
    handlePopoverClose(e);
    onRemove();
  };

  return (
    <div
      className="delete-avatar-container"
      onClick={handlePopoverOpen}
      role="button"
      aria-hidden="true"
    >
      <img src="/images/remove-icon.svg" alt="delete-avatar" />
      <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <RemoveCustomAvatarCard>
          <div>
            <div className="header">Remove Custom Avatar?</div>
            <div className="body">
              Removing the custom image restores the default avatar.
            </div>
          </div>
          <div className="actions">
            <SPWMainButton style={{ padding: '16px' }} onClick={handleRemove}>
              REMOVE
            </SPWMainButton>
            <SPWOutlineBlackButton onClick={handlePopoverClose}>
              CANCEL
            </SPWOutlineBlackButton>
          </div>
        </RemoveCustomAvatarCard>
      </Popover>
    </div>
  );
};

export default RestoreDefaultAvatarPopover;
